import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getPreinvoicesAudit({ commit }, filters = {}) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
      query (
        $warehouses: [Int]
        $logistic_providers: [Int]
        $delivery_methods: [Int]
        $date_range: DateRangeInput
        $status: [String]
        $search_by: String!
        $search_values: [String]
      ) {
        preInvoicesAudit(
          warehouses: $warehouses
          logistic_providers: $logistic_providers
          delivery_methods: $delivery_methods
          date_range: $date_range
          status: $status
          search_by: $search_by
          search_values: $search_values
        ) {
          id
          order_number
          tracking_code
          cte {
            number
            serie
          }
          invoice {
            number
            serie
            value
          }
          doccob {
            number
            serie
          }
          status
          tms_value
          cte_value
          payment_type
        }
      }
    `, filters)
      .then(({ data }) => {
        const { preInvoicesAudit = [] } = data || {};

        preInvoicesAudit.map(({ id }) =>
          commit('setFormInvoiceField', {
            id,
            payment_type: 'tms_value',
          }),
        );

        commit('setPreInvoices', preInvoicesAudit);
        commit('toggleLoading', false);

        return preInvoicesAudit;
      })
      .catch((err) => {
        commit('toggleLoading', false);
        return Promise.reject(err);
      });
  },
  releaseForPayment({ commit }, selectedInvoices) {
    commit('toggleLoading', true);

    const invoices = selectedInvoices.map((item) => {
      const { id, payment_type } = item || {};

      return { id, payment_type };
    });

    return GraphQlClient.mutation(`
      mutation ($invoices: [ReleasePaymentInputType]!) {
        releasePayment(invoices: $invoices) {
          ok
        }
      }
    `, { invoices })
      .then(({ data }) => {
        const { releasePayment = {} } = data || {};
        const { ok = false } = releasePayment || {};

        commit('toggleLoading', false);

        return ok;
      })
      .catch(() => commit('toggleLoading', false));
  },
  reversePreInvoices({ commit }, selectedInvoices) {
    commit('toggleLoading', true);

    const invoices = selectedInvoices.map((item) => {
      const { id, payment_type } = item || {};

      return { id, payment_type };
    });

    return GraphQlClient.mutation(`
      mutation ($invoices: [ReversePreInvoiceInputType]!) {
        reversePreInvoice(invoices: $invoices) {
          ok
        }
      }
    `, { invoices })
      .then(({ data }) => {
        const { reversePreInvoice = {} } = data || {};
        const { ok = false } = reversePreInvoice || {};

        commit('toggleLoading', false);

        return ok;
      })
      .catch(() => commit('toggleLoading', false));
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/pre-invoice-audit/store/actions.js